import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// The decision queue (decisions/index). A review opened from a row runs and
// applies in a dialog; when that dialog closes (Done, Cancel or the close
// button), the page reloads so each row shows its review, its new count, or
// that it is gone. It watches the open attribute across the page: the close
// buttons empty the modal straight after closing, so the dialog's own close
// event fires once it is out of the page, and a stream may swap the modal
// frame itself. The reviews are this page's only dialogs.
export default class extends Controller {
  connect() {
    this.observer = new MutationObserver((records) => {
      const closed = records.some((record) =>
        record.target instanceof HTMLDialogElement && record.oldValue !== null && !record.target.open)
      if (closed) Turbo.visit(window.location.href, { action: "replace" })
    })
    this.observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ["open"], attributeOldValue: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
